module.exports = "pegasus_template/assets/background-patterns/default-space-theme.jpg";